/**
 * Holds some infos about the current environment
 */
export const IS_IOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
export const IS_ANDROID = /Android/i.test(navigator.userAgent);
export const IS_MOBILE = IS_IOS || IS_ANDROID;
// export const IS_IFRAME = window.location !== window.parent.location;
export const IS_PROD = window.location.hostname !== 'localhost' && !window.location.hostname.match(/^192\.168/);
